import type { ReactNode } from 'react'
import type { ShellData } from '@/lib/market/types'

import { LiveProvider } from '@/components/market/live-provider'
import { SiteHeader, StatusBar } from '@/components/generals/site-header'
import SiteFooter from '@/components/generals/site-footer'
import TickerTape from '@/components/market/ticker-tape'

interface SiteShellProps {
    shell: ShellData | null
    children: ReactNode
}

const SiteShell = ({ shell, children }: SiteShellProps): ReactNode => {
    const year = shell?.session.date.slice(0, 4) ?? '2026'

    return (
        <LiveProvider session={shell?.session ?? null}>
            <a
                href='#main-content'
                className='sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-primary focus:px-3 focus:py-2 focus:text-sm focus:font-medium focus:text-primary-foreground'
            >
                Skip to content
            </a>

            <StatusBar shell={shell} />
            <SiteHeader shell={shell} />
            {shell && <TickerTape items={shell.tape} />}

            <div className='flex flex-1 flex-col'>
                {children}
            </div>

            <SiteFooter year={year} />
        </LiveProvider>
    )
}

export default SiteShell
